import type { ReactElement } from 'react';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function MinimumDinnersAlert({ cart }: Props): ReactElement {
  const { minimum_dinners: minDinners } = cart.validations;

  return (
    <Alert type={cart?.alert?.type} heapEvent={cart?.alert?.heapEvent}>
      A minimum of
      <strong>{` ${minDinners} dinners `}</strong>
      must be selected.
    </Alert>
  );
}

export default MinimumDinnersAlert;
